/*
 * Filters content for Sections and Items. Both of these items
 * have a "permissions" property with "roles" and "audience".
 *
 * Returns one array of Sections or Items that matched the user permissions
 *
 * <!> Content audience and role must intercept with User role and audience
 *
 * Example:
 * User: designer, viewer & Section: designer, editor       ->  Content hidden
 * User: non-designer, editor &  Section: designer, editor  ->  Content hidden
 * User: designer, editor & Section: designer, editor       ->  Content visibile
 */
const filterContentByPermissions = ({ userPermissions = 'ALL', contents = [], }) => {
    if (userPermissions === 'ALL') {
        return contents;
    }
    const isUserAdmin = userPermissions.roles.includes('ADMIN');
    const filteredContent = contents.filter(content => {
        var _a, _b;
        // For the Community page, items do not have permissions
        // so we return the item as it is
        if (!('permissions' in content)) {
            return content;
        }
        const contentAudience = ((_a = content.permissions) === null || _a === void 0 ? void 0 : _a.audience) || [];
        const contentRoles = ((_b = content.permissions) === null || _b === void 0 ? void 0 : _b.roles) || [];
        const isAudienceAllowed = !!contentAudience.filter(audience => userPermissions.audience === audience).length;
        const areRolesAllowed = !!contentRoles.filter(role => {
            // If the user is admin and the content is for admins
            // we don't care about the Editor / Viewer role
            if (isUserAdmin) {
                return role === 'ADMIN';
            }
            else {
                return userPermissions.roles.includes(role);
            }
        }).length;
        if (!isAudienceAllowed || !areRolesAllowed) {
            return false;
        }
        return true;
    });
    return filteredContent;
};

export { filterContentByPermissions };
